import PropTypes from "prop-types";

import T from "./translations/Translations";
import { getEducationalTrackWords, getKinderWords, getLanguageWords, getStatusWords } from "../const/SchoolChoice";

/**
 * @name SchoolCard
 * @description SchoolCard component
 * @param {{}} school
 * @returns {JSX.Element}
 */
const SchoolCard = ({ school }) => {
    const { educationalTrack, kinderChoice, kinderOffer, languageChoice, languageOffer, locationDto, status } = school;
    const imgName = languageOffer ? `${locationDto.key}-${languageOffer}` : locationDto.key;
    const schoolName =
        educationalTrack && educationalTrack !== "NOT_APPLICABLE"
            ? `${locationDto.name} ${getEducationalTrackWords(educationalTrack)}`
            : locationDto.name;

    return (
        <div className="school-card">
            <div className="school-card-container">
                <div className="school-card-header">{schoolName}</div>
                <div className="school-card-body">
                    <div className="school-card-img-container">
                        {locationDto && imgName && (
                            <img
                                alt={locationDto.name}
                                height={80}
                                src={`${window.location.origin}/images/${imgName}.png`}
                                title={locationDto.name}
                                width={80}
                            />
                        )}
                    </div>
                    <div className="school-card-data-container">
                        <div className={`school-card-data ${status}`}>
                            <div className="school-card-data-header">
                                {/* Request Status: */}
                                {T({ key: "OEApp_RequestStatus" })}:
                            </div>
                            <hr />
                            <div className="school-card-status">
                                <div className={`status-block ${status}`} />
                                {getStatusWords(status)}
                            </div>
                        </div>
                        {kinderChoice && (
                            <div className="school-card-data">
                                <div className="school-card-data-header">
                                    {/* Kinder Choice: */}
                                    {T({ key: "OEApp_KinderChoice" })}:
                                </div>
                                <hr />
                                <div>{getKinderWords(kinderChoice)}</div>
                            </div>
                        )}
                        {kinderOffer && (
                            <div className="school-card-data">
                                <div className="school-card-data-header">
                                    {/* Kinder Offer: */}
                                    {T({ key: "OEApp_KinderOffer" })}:
                                </div>
                                <hr />
                                <div className="school-card-choice">{getKinderWords(kinderOffer)}</div>
                            </div>
                        )}
                        {languageChoice && (
                            <div className="school-card-data">
                                <div className="school-card-data-header">
                                    {/* Language Choice: */}
                                    {T({ key: "OEApp_LanguageChoice" })}:
                                </div>
                                <hr />
                                <div>{getLanguageWords(languageChoice)}</div>
                            </div>
                        )}
                        {languageOffer && (
                            <div className="school-card-data">
                                <div className="school-card-data-header">
                                    {/* Language Offer: */}
                                    {T({ key: "OEApp_LanguageOffer" })}:
                                </div>
                                <hr />
                                <div>{getLanguageWords(languageOffer)}</div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

SchoolCard.propTypes = {
    school: PropTypes.oneOfType([PropTypes.object]).isRequired
};

export default SchoolCard;
